import { useEffect } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { Button } from "@/Components/Button/Button";
import { NotifySubscribe, NotifyUnsubscribe } from "@/legacy/ApiCallerOld";
import api from "@/Api/Api";

export function PushSubscriptionManager() {
	const [denied, setDenied] = useState(Notification.permission === "denied");
	const [subscribed, setSubscribed] = useState(false);

	useEffect(() => {
		firstUpdated();

		async function firstUpdated() {
			const registration = await navigator.serviceWorker.getRegistration();
			setSubscribed(Boolean(await registration?.pushManager?.getSubscription()));
		}
	}, []);

	async function subscribe() {
		if (process.env.NODE_ENV == "development") {
			toast.error("Push Notifications do not work in dev env. (No service workers).");
			return;
		}

		const notificationPermission = await Notification.requestPermission();

		if (notificationPermission === "granted") {
			const publicKeyRes = await api.BasicGet<string>("/notify/publickey");

			if (!publicKeyRes.successful || publicKeyRes.data == null) {
				toast.error("Could not contact the server.");
				return;
			}

			const registration = await navigator.serviceWorker.getRegistration();

			if (registration == null) {
				toast.error("Could not find service worker.");
				return;
			}

			const subscription = await registration?.pushManager.subscribe({
				userVisibleOnly: true,
				applicationServerKey: urlB64ToUint8Array(publicKeyRes.data),
			});

			if (subscription) {
				setSubscribed(true);
				// Serialize keys uint8array -> base64
				const sub = JSON.parse(JSON.stringify(subscription));
				delete sub.expirationTime;

				await NotifySubscribe(sub);
			}
		} else {
			setDenied(true);
		}
	}

	async function unsubscribe() {
		const registration = await navigator.serviceWorker.getRegistration();
		const subscription = await registration?.pushManager.getSubscription();
		if (subscription) {
			await subscription.unsubscribe();
			await NotifyUnsubscribe(subscription.endpoint);
			setSubscribed(false);
		}
	}

	function urlB64ToUint8Array(base64String: string) {
		const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
		const base64 = (base64String + padding)
			.replace(/-/g, "+")
			.replace(/_/g, "/");
		const rawData = window.atob(base64);
		const outputArray = new Uint8Array(rawData.length);
		for (let i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	}

	return (
		<>
			{denied ?
				<b>
					You have blocked notifications from GoDesk. You will need to manually enable them again in your browser to enable push notifications.
					<br /><br />
				</b>
				:
				subscribed	?
					<>
						Hooray! You are subscribed to receive notifications in this browser.
						<br /><br />
						<Button onClick={unsubscribe} label="Unsubscribe" />
					</>
					:
					<>
						You are not yet subscribed to receive notifications in this browser.
						<br /><br />
						<div>
							<Button onClick={subscribe} disabled={denied} label="Subscribe" />
						</div>
					</>
			}
		</>
	);

}
